import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";
import { setError, setLoaded, setLoading } from "../../LoaderSlice";

export const GetItemTemp = createAsyncThunk(
  'InventoryPosting/fetchtempdetails',
  async (_, { dispatch,rejectWithValue }) => {
    try {
      dispatch(setLoading({ action: 'GetDetailsItem' }));
      const response = await apiClient.get('InventoryPosting/GetbatchNetWt');
      dispatch(setLoaded({ action: 'GetDetailsItem' }));
      return response.data;  
    } catch (error) {
      dispatch(setError({ action: 'GetDetailsItem', message: error.response?.data }));
      dispatch(setLoaded({ action: 'GetDetailsItem' }));
      return rejectWithValue(error.response?.data || 'Error fetching details');
    }
  }
);
export const GetWhsTotalQtybyitem= createAsyncThunk(
  'InventoryPosting/fetchGetWhsQty',
  async ({itemCode,WhsCode},{ rejectWithValue }) => {
    try {
      const response = await apiClient.get(`InventoryPosting/GetItemByWhsQty?ItemCode=${itemCode}&WhsCode=${WhsCode}`);
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching WhsQty ');
    }
  }
);
export const PostInvPosting = createAsyncThunk(
  'InventoryPosting/postInvPosting',  // Action name for redux
  async (tableBody, { rejectWithValue }) => {
    try {
      // Make the POST request with updatedRows as the payload
      const response = await apiClient.post('InventoryPosting/PostIPData',tableBody);
      return response.data;  // Return the response data to be stored in Redux
    } catch (error) {
      // Handle the error and return it with rejectWithValue for better error handling
      return rejectWithValue(error.response?.data || 'Error posting Inventory Posting Data');
    }
  }
);